import { createRoute } from "../../../utils";

import {
  courseChapterExerciseRoutesObj,
  courseChapterExerciseBreadcrumbs,
} from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const courseChapterExercisesRouteMetadata: IRouteMetadataObj<
  typeof courseChapterExerciseRoutesObj
> = {
  create: {
    title: "addNewExercise",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterExercise/page"
      ),
    mode: "create",
    permission,
  },
  edit: {
    title: "editExerciseOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterExercise/page"
      ),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewExerciseOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterExercise/page"
      ),
    mode: "view",
    permission,
  },
};

export const courseChapterExercisesRoutes = createRoute<
  typeof courseChapterExerciseRoutesObj
>(
  courseChapterExerciseRoutesObj,
  courseChapterExercisesRouteMetadata,
  courseChapterExerciseBreadcrumbs,
);
